import { Product } from '@ridango/core';

import { ProductsPartialStoreState, PRODUCTS_BY_CHANNEL_STATE_KEY } from './products.reducer';

export const getAll = (state: ProductsPartialStoreState) => state[PRODUCTS_BY_CHANNEL_STATE_KEY].all;

export const getAllNormalized = (state: ProductsPartialStoreState) => state[PRODUCTS_BY_CHANNEL_STATE_KEY].normalized;

export const getAllIds = (state: ProductsPartialStoreState) => state[PRODUCTS_BY_CHANNEL_STATE_KEY].allIds;

export const getLoading = (state: ProductsPartialStoreState) => state[PRODUCTS_BY_CHANNEL_STATE_KEY].loading;

export const getSelected = (state: ProductsPartialStoreState): Product =>
    state[PRODUCTS_BY_CHANNEL_STATE_KEY].normalized[state[PRODUCTS_BY_CHANNEL_STATE_KEY].selectedProductId];

export const getFixedSumProducts = (state: ProductsPartialStoreState) =>
    state[PRODUCTS_BY_CHANNEL_STATE_KEY].fixedSumProductIds.map(
        (id) => state[PRODUCTS_BY_CHANNEL_STATE_KEY].normalized[id]
    );

export const getVariableSumProduct = (state: ProductsPartialStoreState) =>
    state[PRODUCTS_BY_CHANNEL_STATE_KEY].normalized[state[PRODUCTS_BY_CHANNEL_STATE_KEY].variableSumProductId];

export const getAllProducts = (state: ProductsPartialStoreState) => {
    return state[PRODUCTS_BY_CHANNEL_STATE_KEY].allIds.map((id) => {
        return state[PRODUCTS_BY_CHANNEL_STATE_KEY].byId[id];
    });
    // return state[PRODUCTS_BY_CHANNEL_STATE_KEY].allIds;
};

export const getFilteredProducts = (state: ProductsPartialStoreState) => {
    const products = state[PRODUCTS_BY_CHANNEL_STATE_KEY].filteredProductIds.map((id) => {
        return state[PRODUCTS_BY_CHANNEL_STATE_KEY].byId[id];
    });
    return [...products].sort((a, b) => {
        const va = a?.visual_order;
        const vb = b?.visual_order;
        if (va == null && vb == null) return 0;
        if (va == null) return 1;
        if (vb == null) return -1;
        return va - vb;
    });
};

export const getMatrixProductPrices = (state: ProductsPartialStoreState) =>
    state[PRODUCTS_BY_CHANNEL_STATE_KEY].matrixProductPrices;
